var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-pill-white relative",class:[
    { 'pointer-events-auto opacity-75': _vm.isLoading },
    { 'pointer-events-none opacity-50': _vm.disabled },
    _vm.verticalMargin,
  ],attrs:{"type":"submit"}},[_c('span',{class:{ invisible: _vm.isLoading }},[_vm._t("default")],2),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"absolute inset-0 flex items-center justify-center"},[_c('SpinnerIcon',{staticClass:"animate-spin w-6 h-6"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }